import axios from "axios";
import { FetchError } from "@rollkall/nexus-client";

function isCancelError(error) {
	if (!error) return false;

	/*
	 * The .NET Framework client uses axios for network requests.
	 */
	if (axios.isCancel(error)) return true;

	/*
	 * The .NET Core client uses the Fetch API via the @rollkall/nexus-client package for network requests.
	 */
	if (error instanceof FetchError && error.cause.name === "AbortError") return true;

	return false;
}

function throwNetworkError() {
	const { lang } = global;

	const networkError = { response: { data: { Message: lang.t("NexusNetworkError") } } };
	throw networkError;
}

/*
* When the request fails with `ERR_NETWORK` or `Failed to fetch`, it can happen for various reasons.
*
* 1. The server is down or unreachable.
* 2. The request was blocked by a firewall or network policy.
* 3. The request was aborted due to a timeout or other network issues.
* 4. The browser CORS policy blocked the request.
*
* Since we cannot determine the exact cause of the `ERR_NETWORK` error,
* we handle it by throwing a generic network error message.
*
*/
function throwIfNetworkError(error) {
	if (!error) return;

	if (axios.isAxiosError(error) && error.code === "ERR_NETWORK")
		throwNetworkError();

	if (error.message === "Failed to fetch")
		throwNetworkError();
}

export {
	// eslint-disable-next-line import/prefer-default-export
	isCancelError,
	throwIfNetworkError,
};
